interface IProps {
  content: any;
}

const SiteManager = ({ content }: IProps) => {
  return content;
};

export default SiteManager;
